/**
 * if hsqc is present in experimentTypes we can just predict 13C
 * spectrum and try to assign the carbons first.
 * @param {*} correlations
 * @param {*} justAssign
 */
function getWorkFlow(correlations, justAssign = []) {
    const experimentTypes = extractExperimentType(correlations);
    const { hasHSQC, types } = experimentTypes;
    if (justAssign.length > 0) {
        return { assignmentOrder: justAssign, experimentTypes };
    }
    const assignmentOrder = [];
    if (hasHSQC) {
        assignmentOrder.push(['C'], ['H']);
    }
    else {
        assignmentOrder.push(types.filter((type) => type === 'H' || type === 'C'));
    }
    return { assignmentOrder, experimentTypes };
}
export default getWorkFlow;
function extractExperimentType(correlations) {
    const types = [];
    for (const correlation of correlations) {
        let experimentType = correlation.experimentType;
        if (experimentType === '1d') {
            experimentType = `${correlation.atomType.toUpperCase()}`;
        }
        if (!types.includes(experimentType)) {
            types.push(experimentType);
        }
        for (const link of correlation.link) {
            experimentType = link.experimentType;
            if (experimentType === '1d') {
                experimentType = `${link.atomType[0].toUpperCase()}`;
            }
            if (!types.includes(experimentType)) {
                types.push(experimentType);
            }
        }
    }
    return {
        types,
        hasProton: types.includes('H'),
        hasCarbon: types.includes('C'),
        hasHSQC: types.includes('hsqc'),
    };
}
//# sourceMappingURL=getWorkFlow.js.map